import { ethers } from 'ethers';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { IState } from '../../models/reducers/i-state.interface';

import { WEB3 } from '../../constants/web3.constant';

export interface INftParams {
  nftId?: string;
}

export interface IRNftParams extends INftParams {
  nftName?: string;
  fnftsAmount: number;
  amountRmv?: number;
  transactionHash?: string;
}

export interface ISourceScreen {
  sourceScreen: string;
}

export interface IEvents {
  sendBuyEvent: (params: IRNftParams) => void;
  sendBuySuccessEvent: (params: IRNftParams) => void;
  sendBuyErrorEvent: (params: IRNftParams & IErrorMessageParam) => void;
}

export interface ILoadingTimeParam {
  time: number;
}

export interface IErrorMessageParam {
  message: string;
}

export type IEventParams<T> = Partial<ILoadingTimeParam> & Partial<T>;

export const extractReferrerWallet = (search: string): { referrerWallet?: string } => {
  const searchParams = new URLSearchParams(search);
  const referrerWallet = searchParams.get('referrerWallet');

  if (referrerWallet && ethers.utils.isAddress(referrerWallet)) {
    return { referrerWallet };
  }

  return {};
};

export const useEventParamsMethods = () => {
  const walletAddress = useSelector((state: IState): string => state.wallet.address);
  const storedReferrerWallet = useSelector((state: IState): string | null => state.wallet.referrerWallet);

  const withWalletAddress = <T>(params?: IEventParams<T>) => ({
    walletAddress: !!walletAddress?.length ? walletAddress : WEB3.nullAddress,
    ...params,
  });

  const { search } = useLocation();
  const urlReferrerWallet = extractReferrerWallet(search);

  // Prioritize stored referrerWallet from Redux, fallback to URL
  const referrerWallet = storedReferrerWallet ? { referrerWallet: storedReferrerWallet } : urlReferrerWallet;

  const withWalletAddressAndReferrer = <T>(params?: IEventParams<T>) =>
    withWalletAddress({ ...referrerWallet, ...params });

  return { withWalletAddress, withWalletAddressAndReferrer };
};
